var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 407 239",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Logo_svg__clip0_102_64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.21 88.372v-20.21h-15.77v20.21h15.77z",
    fill: "#BF9A45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.033 87.296V68.962h-12.157v18.334h12.157z",
    fill: "#FFE7AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.051 104.604c-13.673-9.728-13.673-25.502 0-35.231l47.741-33.97c13.673-9.729 35.841-9.73 49.514 0l47.741 33.97c13.673 9.729 13.673 25.502 0 35.231l-47.741 33.97c-13.673 9.729-35.841 9.729-49.514.001l-47.741-33.971z",
    fill: "url(#Logo_svg__paint0_linear_102_64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.051 86.382c-13.673-9.729-13.673-25.502 0-35.231l47.741-33.97c13.673-9.73 35.841-9.73 49.514 0l47.741 33.97c13.673 9.729 13.673 25.502 0 35.231l-47.741 33.97c-13.673 9.729-35.841 9.729-49.514 0l-47.741-33.97z",
    fill: "#F0CD7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.734 170.412v-18.303h-15.86v18.303h15.86z",
    fill: "#BF3B11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.449 170.234v-18.223h-12.218v18.223h12.218z",
    fill: "#FFA284"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.484 187.849c-13.673-9.729-13.673-25.502 0-35.231l47.741-33.97c13.673-9.729 35.841-9.729 49.514 0l47.742 33.97c13.672 9.729 13.672 25.502 0 35.231l-47.742 33.97c-13.673 9.729-35.841 9.729-49.514 0l-47.741-33.97z",
    fill: "url(#Logo_svg__paint1_linear_102_64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.484 169.627c-13.673-9.729-13.673-25.503 0-35.231l47.741-33.971c13.673-9.728 35.841-9.728 49.514 0l47.742 33.971c13.672 9.728 13.672 25.502 0 35.231l-47.742 33.97c-13.673 9.729-35.841 9.729-49.514 0l-47.741-33.97z",
    fill: "#EB6E46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.761 170.805v-19.399h-15.852v19.399h15.852z",
    fill: "#215050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.473 170.448v-18.642H5.246v18.642h12.226z",
    fill: "#60A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.52 187.849c-13.673-9.729-13.673-25.502 0-35.231l47.74-33.97c13.673-9.729 35.842-9.729 49.515 0l47.741 33.97c13.673 9.729 13.673 25.502 0 35.231l-47.741 33.97c-13.673 9.729-35.842 9.729-49.514 0l-47.742-33.97z",
    fill: "url(#Logo_svg__paint2_linear_102_64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.52 169.627c-13.673-9.729-13.673-25.503 0-35.231l47.74-33.971c13.673-9.728 35.842-9.728 49.515 0l47.741 33.971c13.673 9.728 13.673 25.502 0 35.231l-47.741 33.97c-13.673 9.729-35.842 9.729-49.514 0l-47.742-33.97z",
    fill: "#3A6E6E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Logo_svg__paint0_linear_102_64",
    x1: 294.732,
    y1: 84.598,
    x2: 126.474,
    y2: 26.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354,
    stopColor: "#BE9944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#FFE6AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Logo_svg__paint1_linear_102_64",
    x1: 410.165,
    y1: 167.843,
    x2: 241.908,
    y2: 109.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354,
    stopColor: "#BE3B11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#FFA284"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Logo_svg__paint2_linear_102_64",
    x1: 179.2,
    y1: 167.843,
    x2: 10.943,
    y2: 109.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354,
    stopColor: "#215050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#609F9F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Logo_svg__clip0_102_64"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h407v239H0z"
  })))));
}
export default SvgLogo;